import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class AboutService {

  ABOUT_API_BASE_URL= SERVER_API_URL+'about/counts/';

  constructor(
    private http: HttpClient
  ) { }

  getAbout() : Observable<any> {
    return this.http.get<any>(this.ABOUT_API_BASE_URL);
  }
}
